import { render, staticRenderFns } from "./CustomerRegistrationForm.vue?vue&type=template&id=2bcb211e&scoped=true"
import script from "./CustomerRegistrationForm.vue?vue&type=script&lang=js"
export * from "./CustomerRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerRegistrationForm.vue?vue&type=style&index=0&id=2bcb211e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcb211e",
  null
  
)

export default component.exports